import { Controller } from "stimulus";

let gamesIds;
let erasIds;
let eraId;

export default class extends Controller {
  static targets = [ "gamesIds", "erasIds", "eraId", "game", "isFakeDiv", "isFake", "code" ];


  initialize() {
    gamesIds = JSON.parse(this.gamesIdsTarget.innerHTML)
    erasIds = JSON.parse(this.erasIdsTarget.innerHTML)
    eraId = parseInt(this.eraIdTarget.innerHTML)
    if (Number.isNaN(eraId))
      eraId = null

    super.initialize();
    this.changeGame()
  }

  condition() {
    return this.gameTarget.value &&
      (!gamesIds.includes(parseInt(this.gameTarget.value)) || erasIds.includes(eraId))
  }

  changeGame() {
    if (this.condition()) {
      this.isFakeDivTarget.hidden = false;
    }
    else {
      this.isFakeDivTarget.hidden = true;
    }
    this.changeIsFake()
  }

  changeIsFake() {
    this.codeTarget.hidden = this.isFakeTarget.checked || !this.gameTarget.value
  }
}